import { type BoxProps, Text } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { TextBlock as TTextBlock } from "~/core";

export type TextBlockProps = { data: TTextBlock } & Partial<
  Omit<BoxProps, "display" | "as" | "children" | "className" | "onClick">
>;

export const TextBlock: FC<TextBlockProps> = ({ data, ...rest }) => {
  return <Text {...rest} content={data?.content ?? ""} />;
};
